import React from 'react';
export function Footer() {
  return <footer className="w-full bg-sage-dark" data-id="element-100" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-101" data-mp="3gezeh7brdx2q">
        <h3 className="font-display text-2xl text-ochre-soft" data-id="element-102" data-mp="3ghc2o28413o8">
          Gestalt Session Ready
        </h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-cream/70" data-id="element-103" data-mp="32m1awxp5wyo3">
          The Figure-to-Experiment Map — so you never walk into a session
          wondering what experiment to offer.
        </p>

        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-cream/70" data-id="element-104" data-mp="3ud7i1y3avwmv">
          <a href="mailto:help@iclcollective.com" className="hover:text-cream hover:underline" data-id="element-105" data-mp="3lecaoioisghz">
            help@iclcollective.com
          </a>
        </div>

        <p className="mx-auto mt-7 max-w-2xl border-t border-sage-line pt-5 text-xs leading-relaxed text-cream/45" data-id="element-106" data-mp="3qbvmzd1nqj7a">
          Gestalt Session Ready is a professional resource for trained
          therapists and counselors. It supports your clinical judgment; it
          does not teach Gestalt therapy from scratch and does not replace
          training, supervision, or your professional, ethical and legal
          obligations. It is not a treatment and no clinical outcome is
          guaranteed. Case examples are composites with no real client data.
          Not affiliated with or endorsed by any Gestalt institute, training
          body, professional association or author. &copy; Gestalt Session
          Ready 2026 — All rights reserved.
        </p>
      </div>
    </footer>;
}